module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "particles-js",
      "color": _vm.color,
      "particleOpacity": _vm.particleOpacity,
      "linesColor": _vm.linesColor,
      "particlesNumber": _vm.particlesNumber,
      "shapeType": _vm.shapeType,
      "particleSize": _vm.particleSize,
      "linesWidth": _vm.linesWidth,
      "lineLinked": _vm.lineLinked,
      "lineOpacity": _vm.lineOpacity,
      "linesDistance": _vm.linesDistance,
      "moveSpeed": _vm.moveSpeed,
      "hoverEffect": _vm.hoverEffect,
      "hoverMode": _vm.hoverMode,
      "clickEffect": _vm.clickEffect,
      "clickMode": _vm.clickMode
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-3dfed353"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/vue-particles/vue-particles.vue
// module id = 1463
// module chunks = 1